"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectSwitchComponent = void 0;
const React = __importStar(require("react"));
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const lodash_1 = __importDefault(require("lodash"));
const react_router_dom_1 = require("react-router-dom");
const PrivateRoute_1 = require("src/hello_assets/src/components/system/PrivateRoute");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const ProjectIntegrationPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/noData/ProjectIntegrationPage");
const withProject_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/withProject");
const ProjectErrorActorPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/noData/ProjectErrorActorPage");
const ProjectMembersPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/members/ProjectMembersPage");
const ProjectParticipantsProvider_1 = __importDefault(require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectParticipantsProvider"));
const ProjectWithDataSwitchComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/ProjectWithDataSwitchComponent");
// const CurrentProjectDataProviderWrapped = (props: PropsWithChildren<any>) => {
//     const projectContext = useCurrentProjectContext();
//
//     return <CurrentProjectDataProvider key={projectContext?.projectApiKey}>
//         {props.children}
//     </CurrentProjectDataProvider>
// }
const ProjectMembersPageWrapped = () => (0, withProject_1.withProject)(React.createElement(ProjectMembersPage_1.ProjectMembersPage, null));
const ProjectWithDataSwitchComponentWrapped = () => (0, withProject_1.withProject)(React.createElement(ProjectWithDataSwitchComponent_1.ProjectWithDataSwitchComponent, null));
const ProjectSwitchComponent = () => {
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const matchMembers = (0, react_router_dom_1.useRouteMatch)(AppRouting_1.PATH__PROJECT_MEMBERS);
    const matchIntegration = (0, react_router_dom_1.useRouteMatch)(AppRouting_1.PATH__PROJECT_INTEGRATION);
    const shouldSkipProjectDataAnalysis = !lodash_1.default.isNil(matchMembers) || !lodash_1.default.isNil(matchIntegration);
    const projectData = projectsContext.getProjectData(projectApiKey);
    if (!shouldSkipProjectDataAnalysis) {
        if (!lodash_1.default.isNil(projectData.error)) {
            return React.createElement(ProjectErrorActorPage_1.ProjectErrorActorPage, { error: projectData.error });
        }
        if (!projectData.state.hasData) {
            return React.createElement(react_router_dom_1.Redirect, { to: AppRouting_1.AppPathGenerator.Project.integration(projectApiKey) });
        }
    }
    // return useMemo(() => {
    return React.createElement(ProjectParticipantsProvider_1.default, null,
        React.createElement(react_router_dom_1.Switch, null,
            React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__PROJECT_MEMBERS, exact: true, component: ProjectMembersPageWrapped }),
            React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__PROJECT_INTEGRATION, component: ProjectIntegrationPage_1.ProjectIntegrationPage }),
            React.createElement(react_router_dom_1.Route, null,
                React.createElement(ProjectWithDataSwitchComponentWrapped, null))));
    // }, [])
};
exports.ProjectSwitchComponent = ProjectSwitchComponent;
